import { supabase } from '../config/supabase';
import Cookies from 'js-cookie';

// Helper to check if we are using placeholder credentials
const isDemoMode = () => {
  return !import.meta.env.VITE_SUPABASE_URL || import.meta.env.VITE_SUPABASE_URL === 'https://placeholder-project.supabase.co';
};

export const signUp = async (email, password) => {
  if (isDemoMode()) {
    console.warn('Demo Mode: Sign up simulated');
    await new Promise(resolve => setTimeout(resolve, 1000));
    return { data: { user: { email } }, error: null };
  }
  
  const { data, error } = await supabase.auth.signUp({
    email,
    password,
    options: {
      emailRedirectTo: `${window.location.origin}/login?verified=true`
    }
  });
  return { data, error };
};

export const signIn = async (email, password) => {
  if (isDemoMode()) {
    console.warn('Demo Mode: Sign in simulated');
    await new Promise(resolve => setTimeout(resolve, 1000));
    const fakeToken = 'demo-token-' + Math.random();
    Cookies.set('auth_token', fakeToken, {
      expires: 7,
      secure: true,
      sameSite: 'strict'
    });
    return { 
      data: { 
        session: { access_token: fakeToken, user: { email, id: 'demo-user-id' } },
        user: { email, id: 'demo-user-id' }
      }, 
      error: null 
    };
  }

  const { data, error } = await supabase.auth.signInWithPassword({
    email,
    password
  });
  
  if (data?.session) {
    Cookies.set('auth_token', data.session.access_token, {
      expires: 7,
      secure: true,
      sameSite: 'strict'
    });
  }
  
  return { data, error };
};

export const signOut = async () => {
  Cookies.remove('auth_token');
  if (isDemoMode()) {
    return { error: null };
  }
  const { error } = await supabase.auth.signOut();
  return { error };
};

export const resetPassword = async (email) => {
  if (isDemoMode()) {
    console.warn('Demo Mode: Reset password simulated');
    await new Promise(resolve => setTimeout(resolve, 1000));
    return { data: {}, error: null };
  }

  const { data, error } = await supabase.auth.resetPasswordForEmail(email, {
    redirectTo: `${window.location.origin}/login?reset=true`
  });
  return { data, error };
};

export const getCurrentUser = async () => {
  if (isDemoMode()) {
    const token = Cookies.get('auth_token');
    if (token) {
      return { user: { email: 'demo@example.com', id: 'demo-user-id' }, error: null };
    }
    return { user: null, error: null };
  }

  const { data: { user }, error } = await supabase.auth.getUser();
  return { user, error };
};

export const isAdmin = async () => {
  const { user } = await getCurrentUser();
  if (!user) return false;
  
  // In demo mode, treat the demo user as admin if the email matches or if no admin email is set
  if (isDemoMode()) {
    return true; 
  }

  const adminEmail = import.meta.env.VITE_ADMIN_EMAIL;
  return user?.email === adminEmail;
};